import { API_URL } from '@/shared/constants/strings';

export default function LoginViaGoogle() {
  const handleGoogleLogin = () => {
    window.location.href = `${API_URL}auth/google`;
  };

  return (
    <>
      <div className="loginform-group" title="Indisponível">
        <p>
          Faça login rapidamente utilizando sua conta institucional do Google.
        </p>
        <br />
        <button
          type="button"
          className="form-control btn btn-warning submit"
          onClick={handleGoogleLogin}
          disabled
        >
          Login com o Google
        </button>
      </div>
    </>
  );
}
